<template>
  <div class="preview-record">
    <div class="record-time-line">
        <div class="rc-slider">
          <div class="rc-slider-track" :style="{'width': playTime/playAllTime*100 + '%'}"></div>
        </div>
    </div>
    <div class="record-button" v-show="IsDoingSmartVoice">
      <div class="record-complete">
        <div class="complete-left">
          <div v-show="playStatus !== 'stop'" class="stop">
            <div @click="playSound('stop')"></div>
            <p>停止</p>
          </div>
          <div v-show="playStatus !== 'start'" class="start">
            <div @click="playSound(playStatus === 'pause'? 'continue' : 'start')"></div>
            <p>{{playStatus === 'pause'? '继续试听' : '试听'}}</p>
          </div>
          <div v-show="playStatus === 'start'" class="pause">
            <div @click="playSound('pause')"></div>
            <p>暂停</p>
          </div>
        </div>
        <div class="back-to-smart-voice" style="cursor: pointer" @click="back">返回AI配音</div>
        <div class="smart-voice-time">
          <div class="row">
            <span>视频时长：</span>
            <span>{{this.playTimeInfo.currentTime.text}}</span>/<span>{{this.playTimeInfo.duration.text}}</span>
          </div>
          <div class="row">
            <span>配音时长：</span>
            <span>{{this.audioTimeInfo.currentTime.text}}</span>/<span>{{this.audioTimeInfo.duration.text}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="record-button" v-show="!IsDoingSmartVoice">
        <div v-if="recordStatus === 'before'" class="record-before">
          <div @click="recordStart()"></div>
          <p>点击开始录音</p>
        </div>
        <div v-else-if="recordStatus === 'ready'" class="record-ready">
          <div>{{readyInfo}}</div>
          <p>开始准备录音</p>
        </div>
        <div v-else-if="recordStatus === 'ing'" class="record-ing">
          <div class="ing-left">
            <div></div>
            <p>正在录音中...</p>
          </div>
          <p></p>
          <div class="ing-right">
            <div class="ing-time">
              <span>{{recordTime | secToMin}}</span>
              <span>(最长可录制{{maxTime | secToMin}})</span>
            </div>
            <el-button type="primary" class="ing-button" @click="shotClock('stop');analysisC('stop')">结束录音</el-button>
          </div>
        </div>
        <div v-else-if="recordStatus === 'complete'" class="record-complete">
          <div class="complete-left">
            <div v-show="playStatus !== 'stop'" class="stop">
              <div @click="playSound('stop')"></div>
              <p>停止</p>
            </div>
            <div v-show="playStatus !== 'start'" class="start">
              <div @click="playSound(playStatus === 'pause'? 'continue' : 'start')"></div>
              <p>{{playStatus === 'pause'? '继续试听' : '试听'}}</p>
            </div>
            <div v-show="playStatus === 'start'" class="pause">
              <div @click="playSound('pause')"></div>
              <p>暂停</p>
            </div>
          </div>
          <p></p>
          <div class="complete-right">
            <span>{{soundPlay | secToMin}}/{{soundTime | secToMin}}</span>
            <div class="complete-button">
              <el-button type="primary" @click="saveRecord();analysisC('complete')">录好了</el-button>
              <el-button @click="reRecord();analysisC('reStart')">重新录</el-button>
            </div>
          </div>
        </div>
    </div>
    <audio id="testtest" style="display:none" ref="recordDom"  :src="SmartVoicePreviewUrl || recordUrl"></audio>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'previewRecord',
  computed: {
    ...mapGetters([
      "TOOL",
      "SelectScenes_Msg",
      "IsDoingSmartVoice",
      "SmartVoicePreviewUrl"
    ]),
  },
  data () {
    return {
      ANALYSIS: {
        start : {category:'recording_classification', action:'click_start_recording', label:'开始录音'},
        stop : {category:'recording_classification', action:'click_stop_recording', label:'录音_结束录音'},
        complete : {category:'recording_classification', action:'click_complete_recording', label:'录音_录好了'},
        reStart : {category:'recording_classification', action:'click_re-start_recording', label:'录音_重新录'},
      },
      playTime: 0,              // 播放时间，用于进度条的显示
      playAllTime: 0,           // 播放的最大时间，区别最大录音时间，也是用于进度条
      maxTime: 0,               // 最长可录制的时间（ms)
      recordStatus: 'before',   // 录音的状态
      playStatus: 'stop',       // 播放的状态
      recorder: null,           // 用于承载录音开始和停止的对象
      stream: null,             // 打开麦克风后的对象，用于关闭麦克风和接收麦克风数据
      audioChunks: null,        // 录音后的数据数组
      readyInfo: 3,             // 准备录音的倒计时显示
      recordTime: 0,            // 当前录音时间的显示
      soundTime: 0,             // 录音的总时间
      soundPlay: 0,             // 录音的播放时间
      clockTime: 0,             // 用于控制播放时间的变量
      recordUrl: '',            // 录音完成后生成的url(base64)
      canPlaySound: false,      // 是否可以播放录音（好像暂时也没有判断）
      breakAll: false,          // 关闭录音
      audioDuration: 0,
      audioCurrentTime: 0,
      audioTimeInfo: {
        duration: {text: ''},
        currentTime: {text: ''}
      },
      playTimeInfo: {
        duration: {text: ''},
        currentTime: {text: ''}
      }
    }
  },
  props: ['soundType', 'nowTime', 'totalTime'],
  mounted () {
    this.initData();
    this.$refs.recordDom.addEventListener('durationchange', (data) => {
      this.canPlaySound = true;
    })
    this.$refs.recordDom.addEventListener('timeupdate', (data) => {
      this.soundPlay = data.target.currentTime * 1000;
      this.soundTime = data.target.duration * 1000;
    })
    this.$refs.recordDom.addEventListener('ended', (data) => {
      // 录音播放完毕
      this.soundType === 'all' && this.$bus.emit('preview-record-play', {status: 'stop'});
      this.playStatus = 'stop';
      this.soundPlay = 0;
      this.playTime = 0;
      this.clockTime = 0;
    })
    this.$bus.on('saveUploadRecord', data => {
      // 保存录音的事件
      data.duration = this.soundTime / 1000;
      this.uploadRecord(data)
    })
    this.$bus.on('record_close_before', this._closeBefore)
    this.$bus.on('record_close_ing', (data) => {
      // 关闭录音与弹窗
      if(this.recordStatus === 'ing') {
          this.shotClock('stop');
      }
      if(data.type === 'close') {
        this.$bus.emit('record_close_complete')
      } else {
        this.saveRecord()
      }
    });

    $('#testtest').on('loadedmetadata', (ev) => {
      this.audioDuration = ev.target.duration;
      this.audioTimeInfo = this.getAudioTimeInfo({
        duration: this.audioDuration,
        currentTime: 0
      });
    });
    $('#testtest').on('timeupdate', (ev) => {
      this.audioCurrentTime = ev.target.currentTime;
      this.audioTimeInfo = this.getAudioTimeInfo({
        duration: this.audioDuration,
        currentTime: this.audioCurrentTime
      });
    });
  },
  watch: {
    nowTime (val, oldval) {
      if(this.soundType === 'all') {
        if(val < this.playAllTime) {
          this.playTime = val;
        }
      }
    },
    clockTime(val, oldval) {
      this.recordTime = val;
      if(this.soundType === 'select') {
        if(val < this.playAllTime) {
          this.playTime = val;
          if(!this.SelectScenes_Msg.sprites && !this.SelectScenes_Msg.id) return;
          let frame = Math.ceil(val / 1000 * 60);
          // eve('playByFrame', null, frame || 1, this.SelectScenes_Msg.id)
          this.TOOL.eve.emit('play_' + this.SelectScenes_Msg.id, frame || 1);
        }
      }
    },
    playAllTime (val) {
      let currentTime = 0;
      let duration = Math.round(val / 1000);
      this.playTimeInfo = this.getPlayTimeInfo({
        duration,
        currentTime
      });
    },
    playTime (val) {
      if (val === 0) {
        $('#testtest').prop('currentTime', 0);
      }
      let currentTime = Math.round(val / 1000) + this.getSceneBeforeDuration();
      let duration = Math.round(this.playAllTime / 1000);
      this.playTimeInfo = this.getPlayTimeInfo({
        duration,
        currentTime
      });
    }
  },
  methods: {
    initData() {
      // 初始话数据
      this.resetData();
      if(this.soundType === 'select') {
        this.playAllTime = this.SelectScenes_Msg.getDuration()
        this.maxTime = 30000;
      } else if(this.soundType === 'all') {
        this.maxTime = 360000;
        this.playAllTime = this.totalTime;
      }
    },
    async recordStart() {
      // 录音开始按钮
      await this.recordAudio();
      this.recordStatus = 'ready';
      this.countDown();
      await this.sleep(4000);
      if(this.breakAll) {
        this.stream.getTracks()[0].stop();
        return;
      }
      this.playTool('play')
      this.recorder.start()
      this.recordStatus = 'ing';
      this.$analysis(this.ANALYSIS.start);
    },
    recordAudio () {
      // 获取录音数据以及绑定开始和停止录音的方法
      return new Promise(async resolve => {
        this.stream = await navigator.mediaDevices.getUserMedia({audio: {
          sampleRate: 44100, // 采样率
          channelCount: 2,   // 声道
          volume: 1.0        // 音量
        }})
        const mediaRecorder = new MediaRecorder(this.stream);
        this.audioChunks = [];
        this.recorder = {};

        mediaRecorder.addEventListener("dataavailable", event => {
          this.audioChunks.push(event.data);
        });

        this.recorder.start = () => mediaRecorder.start();

        this.recorder.stop = () =>
          new Promise(resolve => {
            mediaRecorder.addEventListener("stop", () => {
              const audioBlob = new Blob(this.audioChunks);
              const audioUrl = URL.createObjectURL(audioBlob)
              resolve({audioBlob, audioUrl});
            });
            mediaRecorder.stop();
          });

        resolve();
      })
    },
    sleep: function(time) {
      return new Promise(resolve => setTimeout(resolve, time))
    },
    stopAudio () {
      // 停止录音
      if(this.recordStatus !== 'ing') return;
      this.recorder && this.recorder.stop().then(({audioBlob,audioUrl}) => {
        this.recordStatus = 'complete';
        this.recordUrl = audioUrl;
      })
      this.soundTime = this.clockTime;
      this.soundType === 'all' && this.$bus.emit('preview-record-play', {status: 'stop'});
      this.stream.getTracks()[0].stop();
    },
    countDown() {
      // 录音倒计时
      this.readyInfo = 3;
      let clock = setInterval(() => {
        this.readyInfo--;
        if(this.readyInfo <= 0) {
          this.readyInfo = 'GO';
          clearInterval(clock);
        }
      }, 1000)
    },
    playTool(type) {
      // 画布播放的方法
      if(this.soundType === 'all') {
        this.$bus.emit('preview-record-play', {status: type});
      }
      this.shotClock('start');
    },
    playSound (type) {
      // 播放，暂停，停止录音声音
      this.playStatus = type;
      if(this.soundType === 'all') {
        if(type === 'start' || type === 'continue') {
          this.$bus.emit('preview-record-play', {status: 'play'});
          this.playStatus = 'start';
        }else {
          this.$bus.emit('preview-record-play', {status: type});
        }
      }
      if(type === 'start') {
        this.soundTime = this.$refs.recordDom.duration * 1000;
        this.$refs.recordDom.currentTime = 0;
        this.$refs.recordDom.play();
        this.shotClock(this.playStatus, 0, this.soundTime)
      } else if(type === 'pause') {
        this.$refs.recordDom.pause();
        this.shotClock(this.playStatus)
      } else if(type === 'stop') {
        this.$refs.recordDom.pause();
        this.$refs.recordDom.currentTime = 0;
        this.shotClock(this.playStatus)
      } else if (type === 'continue') {
        this.$refs.recordDom.play();
        this.$refs.recordDom.currentTime = this.soundPlay / 1000
        this.playStatus = 'start';
        this.shotClock(this.playStatus, this.soundPlay, this.soundTime)
      }
    },
    shotClock(type, startTime=0, endTime=0) {
      // 单页录音的播放在这里控制
      let start = null,
          step = null;

      step = (timestamp) => {
        if(type === 'start') {
          let progress = 0;
          if(!start) start = timestamp;
          progress = timestamp - start;
          this.clockTime = progress + startTime;
          if(this.clockTime >= this.maxTime) {
            this.clockTime = this.maxTime;
            window.cancelAnimationFrame(this.animFrame);
            this.stopAudio()
          } else if(endTime && this.clockTime >= endTime){
            window.cancelAnimationFrame(this.animFrame);
          } else {
            this.animFrame = window.requestAnimationFrame(step);
          }
        } else if(type === 'stop') {
          window.cancelAnimationFrame(this.animFrame);
          this.clockTime && this.stopAudio()
          this.clockTime = 0;
        } else if(type === 'pause'){
          window.cancelAnimationFrame(this.animFrame);
        } else {
          window.cancelAnimationFrame(this.animFrame);
          this.clockTime = 0;
        }
      }

      this.animFrame = window.requestAnimationFrame(step);
    },
    reRecord() {
      // 重新录音
      this.playSound('stop');
      this.resetData();
    },
    resetData() {
      this.recordStatus = 'before';
      this.playTime = 0;
      this.playStatus = 'stop';
      this.recordTime = 0;
      this.soundTime = 0;
      this.soundPlay = 0;
      this.clockTime = 0;
      this.canPlaySound = false;
      this.breakAll = false;
    },
    saveRecord() {
      // 保存录音
      this.playStatus === 'play' && this.playSound('stop');
      this.$modal.show('saveRecord', {type: this.soundType});
    },
    uploadRecord(data) {
      // 上传录音
      let formData = new FormData();
      formData.append(name, this.audioChunks[0]);
      this.$http({
        url: '/api/upload/file/',
        method: 'post',
        data: formData,
      }).then(res => {
        if(res.data.code === 200) {
          let infoData = {
            title: data.name,
            url: res.data.data.filename,
            duration: data.duration,
            musicType: 1
          }
          this.$http.post('/api/user/music', infoData).then( resInfo => {
            let resData = resInfo.data.data;
            let audioInfo = {
              fileType: resData.fileType,
              id: resData.id,
              resourceId: resData.id,
              startTime: 0,
              title: resData.title,
              url: this.$handleAssetsUrl(resData.url)
            }
            this.$bus.emit('record_upload_success');
            this.$bus.emit('record_close_complete')
            // this.judgeAudio(audioInfo, data.select)
          }).catch( errInfo => {
            this.$message({
              showClose: true,
              message: '文件上传错误，请重试！',
              type: 'error'
            });
          })
        }else {
          this.$message({
            showClose: true,
            message: '文件上传错误，请重试！',
            type: 'error'
          });
        }
      }).catch(err => {
        this.$message({
          showClose: true,
          message: '上传错误！请检查网络或文件格式',
          type: 'error'
        });
      })
    },
    judgeAudio(data, type) {
      // 判断是否转码成功（暂时没有用到）
      let audio = document.createElement('audio');
      audio.addEventListener('loadedmetadata', (e)=>{
        this.$bus.emit('record_close_complete')
        setTimeout( () => {
          if(type === 'all') {
            this.$bus.emit('addAudioToGlobal', data);
          } else {
            this.$bus.emit('addAudioToScene', data);
          }
        })
      });
      audio.onerror = (e)=>{
        let timeoutid = setTimeout(() => {
          this.judgeAudio(data, type);
          clearTimeout(timeoutid);
        }, 2000);
      };
      audio.src = data.url;
    },
    analysisC (type) {
      this.$analysis(this.ANALYSIS[type])
    },

    back () {
      this.$bus.emit('record_close_complete');
      this.$store.commit('save_SoundRecord', {
        isShowGenerateVoice: true,
      });
      this.$analysis('ai_dub，click_dub_video_preview_back，AI配音视频_预览_返回')
    },
    _closeBefore(){
      // 关闭事件前的判断
      if(this.recordStatus === 'ing' || this.recordStatus === 'complete') {
        this.$modal.show('leaveRecord');
      } else {
        this.breakAll = true;
        this.$bus.emit('record_close_complete')
      }
    },
    getAudioTimeInfo (input) {
      let d = {};
      let c = {};
      d.value = input.duration || 0;
      c.value = input.currentTime || 0;
      d.text = this.$util.formatDur(d.value);
      c.text = this.$util.formatDur(c.value);
      return {
        duration: d,
        currentTime: c,
      }
    },
    getPlayTimeInfo (...args) {
      return this.getAudioTimeInfo(...args);
    },
    getSceneBeforeDuration () {
      let currScene = this.TOOL.selectedScenes;
      let dur = 0;
      for (let i = 0; i < currScene.index; i++) {
        dur += this.TOOL.sprites[i].duration
      }
      dur = Math.round(dur / 1000);

      return dur
    }
  },
  filters: {
    secToMin(duration) {
      if(duration <= 0) return "00:00";
      if (!duration || duration === Infinity) return "--:--";
      duration = parseFloat(duration / 1000);
      var min = Math.floor(duration / 60);
      min = (min + "").length === 1 ? "0" + min : min;
      var sec = Math.round(duration % 60);
      sec = (sec + "").length === 1 ? "0" + sec : sec;
      min = min || "00";
      sec = sec || "00";
      return min + ":" + sec;
    }
  },
  beforeDestroy () {
    this.$bus.off('saveUploadRecord')
    this.$bus.off('record_close_before', this._closeBefore)
    this.$bus.off('record_close_ing')
  }
}
</script>

<style lang="scss" scoped>
.preview-record {
  width: 100%;
  height: 100%;

  .record-time-line {
    width: 100%;
    display: flex;
  }

  .rc-slider {
    position: relative;
    height: 6px;
    width: 100%;
    background-color: #fff;
    -ms-touch-action: none;
    touch-action: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .rc-slider-track {
    position: absolute;
    background-color: #5778FB;
    height: 6px;
    left: 0%;
    width: 69.1515%;
  }
}


.record-button {
  width: 100%;
  display: flex;
  height: calc(100% - 6px);
  vertical-align: middle;
  justify-content: center;
}

.record-before, .record-ready, .ing-left {
  margin-top: 30px;
  text-align: center;
  color: #454463;

  div {
    display: inline-block;
    margin-bottom: 8px;
    width: 62px;
    height: 62px;
    border-radius: 50%;
    background: url('../../../static/img/recordStart.png') no-repeat center;
    background-color: #454463;
    cursor: pointer;
  }
}
.record-ready div {
  font-size: 24px;
  line-height: 62px;
  color: #fff;
  font-weight: bolder;
  background: #EA3E3E;
}

.record-ing, .record-complete {
  display: flex;
  justify-content: center;

  >p {
    margin: 30px 50px 0 50px;
    height: 59%;
    border-left: 1px solid #ddd;
  }
}

.ing-left div {
  background: url('../../../static/img/recording.gif') no-repeat center;
  background-color: #EA3E3E;
}

.ing-right, .complete-right {
  display: flex;
  margin-top: 30px;
  flex-direction: column;
}
.ing-time {
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;

  span:first-child {
    font-size: 23px;
    margin-right: 5px;
  }
  span:last-child {
    color: #888;
  }
}
.ing-button {
  width: 100px;
  height: 38px;
}

.complete-left {
  display: flex;
  margin-top: 30px;
  justify-content: flex-end;
  width: 235px;

  >div {
    text-align: center;
    color: #454463;
    margin-left: 55px;

    div {
      display: inline-block;
      margin-bottom: 8px;
      width: 62px;
      height: 62px;
      // border-radius: 50%;
      background-size: 36%;
      background-color: #454463;
      cursor: pointer;
    }
  }

  .start div{
    background: url('../../../static/svg/play.svg');
    &:hover {
      background: url('../../../static/svg/play-active.svg');
    }
  }
  .pause div{
    background: url('../../../static/svg/pause.svg');
    &:hover {
      background: url('../../../static/svg/pause-active.svg');
    }
  }
  .stop div{
      background: url('../../../static/svg/stop.svg');
      &:hover {
        background: url('../../../static/svg/stop-active.svg');
    }
  }
}
.complete-right {
  text-align: left;

  span {
    margin-bottom: 25px;
    font-size: 22px;
  }

  button {
    width: 100px;
    height: 34px;
    padding: 5px;
  }

  button:last-child{
    border-color: #454463;
    background-color: #f0f0f8;
  }
}
.complete-button {
  button:last-child:hover {
    border-color: #5778FB;
  }
}

.back-to-smart-voice {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translatey(-50%);
  width: 120px;
	height: 38px;
	line-height: 38px;
	background-color: #5778fb;
	border-radius: 4px;
  border: solid 1px #f0f0f8;

	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
}

.smart-voice-time {
  position: absolute;
  top: 14px;
  left: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/modal/previewRecord.vue